import home from './routes'

export default [...home] as const
